import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconPlus from "@arco-design/web-react/icon/react-icon/IconPlus";
import React from 'react';
export function ButtonCreate({
  onClick
}) {
  return /*#__PURE__*/React.createElement(_Button, {
    icon: /*#__PURE__*/React.createElement(_IconPlus, null),
    size: "small",
    onClick: onClick,
    type: "primary"
  }, "\u65B0\u5EFA");
}